import { render } from "./CreateAffectation.vue?vue&type=template&id=57cb8413"
import script from "./CreateAffectation.vue?vue&type=script&lang=js"
export * from "./CreateAffectation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__